/**
 * FAQ Component - Hochprofessionelle FAQ-Funktionalität
 * Kompilierte Version für Shopify Assets
 */

class FAQComponent {
  constructor() {
    this.sections = document.querySelectorAll('.faq-section');
    this.faqDetails = document.querySelectorAll('.faq-details');

    this.animationDuration = 300;

    this.init();
  }

  init() {
    if (this.sections.length === 0) return;

    this.setupAccordions();
    this.setupKeyboardNavigation();
    this.setupAccessibility();
    this.setupAnimations();
  }



  setupAccordions() {
    this.faqDetails.forEach(details => {
      const summary = details.querySelector('.faq-summary');

      if (summary) {
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleAccordion(details);
        });
      }
    });
  }

  toggleAccordion(details) {
    const isOpen = details.open;
    const content = details.querySelector('.faq-answer-wrapper');

    if (!content) return;

    if (isOpen) {
      this.closeAccordion(details, content);
    } else {
      this.openAccordion(details, content);
    }
  }

  openAccordion(details, content) {
    details.open = true;

    const height = content.scrollHeight;

    content.style.height = '0px';
    content.style.overflow = 'hidden';

    content.offsetHeight;

    content.style.transition = `height ${this.animationDuration}ms ease`;
    content.style.height = height + 'px';

    setTimeout(() => {
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
    }, this.animationDuration);
  }

  closeAccordion(details, content) {
    const height = content.scrollHeight;

    content.style.height = height + 'px';
    content.style.overflow = 'hidden';

    content.offsetHeight;

    content.style.transition = `height ${this.animationDuration}ms ease`;
    content.style.height = '0px';

    setTimeout(() => {
      details.open = false;
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
    }, this.animationDuration);
  }

  setupKeyboardNavigation() {
    this.faqDetails.forEach(details => {
      const summary = details.querySelector('.faq-summary');

      if (summary) {
        summary.addEventListener('keydown', (e) => {
          switch (e.key) {
            case 'Enter':
            case ' ':
              e.preventDefault();
              this.toggleAccordion(details);
              break;
            case 'ArrowDown':
              e.preventDefault();
              this.focusNextFAQ(summary);
              break;
            case 'ArrowUp':
              e.preventDefault();
              this.focusPreviousFAQ(summary);
              break;
            case 'Home':
              e.preventDefault();
              this.focusFirstFAQ(summary);
              break;
            case 'End':
              e.preventDefault();
              this.focusLastFAQ(summary);
              break;
          }
        });
      }
    });
  }

  focusNextFAQ(currentSummary) {
    const section = currentSummary.closest('.faq-section');
    const summaries = Array.from(section.querySelectorAll('.faq-summary'));
    const currentIndex = summaries.indexOf(currentSummary);
    const nextIndex = (currentIndex + 1) % summaries.length;
    summaries[nextIndex].focus();
  }

  focusPreviousFAQ(currentSummary) {
    const section = currentSummary.closest('.faq-section');
    const summaries = Array.from(section.querySelectorAll('.faq-summary'));
    const currentIndex = summaries.indexOf(currentSummary);
    const prevIndex = currentIndex === 0 ? summaries.length - 1 : currentIndex - 1;
    summaries[prevIndex].focus();
  }

  focusFirstFAQ(currentSummary) {
    const section = currentSummary.closest('.faq-section');
    const firstSummary = section.querySelector('.faq-summary');
    if (firstSummary) firstSummary.focus();
  }

  focusLastFAQ(currentSummary) {
    const section = currentSummary.closest('.faq-section');
    const summaries = section.querySelectorAll('.faq-summary');
    const lastSummary = summaries[summaries.length - 1];
    if (lastSummary) lastSummary.focus();
  }

  setupAccessibility() {
    this.faqDetails.forEach((details, index) => {
      const summary = details.querySelector('.faq-summary');
      const content = details.querySelector('.faq-answer-wrapper');

      if (summary && content) {
        const summaryId = `faq-summary-${index}`;
        const contentId = `faq-content-${index}`;

        summary.id = summaryId;
        summary.setAttribute('aria-expanded', details.open);
        summary.setAttribute('aria-controls', contentId);

        content.id = contentId;
        content.setAttribute('aria-labelledby', summaryId);

        const observer = new MutationObserver(() => {
          summary.setAttribute('aria-expanded', details.open);
        });

        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
      }
    });
  }

  setupAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
        }
      });
    }, observerOptions);

    document.querySelectorAll('.faq-item-wrapper').forEach(item => {
      observer.observe(item);
    });
  }

  openAllFAQs(sectionId = null) {
    const sections = sectionId ?
      [document.getElementById(sectionId)] :
      Array.from(this.sections);

    sections.forEach(section => {
      if (section) {
        section.querySelectorAll('.faq-details').forEach(details => {
          if (!details.open) {
            this.openAccordion(details, details.querySelector('.faq-answer-wrapper'));
          }
        });
      }
    });
  }

  closeAllFAQs(sectionId = null) {
    const sections = sectionId ?
      [document.getElementById(sectionId)] :
      Array.from(this.sections);

    sections.forEach(section => {
      if (section) {
        section.querySelectorAll('.faq-details').forEach(details => {
          if (details.open) {
            this.closeAccordion(details, details.querySelector('.faq-answer-wrapper'));
          }
        });
      }
    });
  }


}

document.addEventListener('DOMContentLoaded', () => {
  window.faqComponent = new FAQComponent();
});
